module.exports = __webpack_public_path__ + "_assets/img/success-icon.730502a0.svg";